export const SET_UNIQUE_YEARS = "SET_UNIQUE_YEARS";
export const SET_SELECTED_YEARS = "SET_SELECTED_YEARS";
export const SET_RELATED_ENGAGEMENT = "SET_RELATED_ENGAGEMENT";
export const SET_ENGAGEMENT_TASK = "SET_ENGAGEMENT_TASK";
export const SET_ENGAGEMENT_ID = "SET_ENGAGEMENT_ID";
export const SET_REFRESH = "SET_REFRESH";
export const SET_LOADING = "SET_LOADING";